module.exports = __webpack_public_path__ + "europa-20_hologram.jpg?797b385ebd14c5225c78e11ae7be01a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20_hologram.jpg
// module id = 333
// module chunks = 0